export default __webpack_public_path__ + "static/media/20200926_145905.bec2f860.jpg";